import { Attachment, AttachmentTypes } from "@/store/chats/types";

export const getIsAttachmentForDeletion = ({
  isUploading,
  type,
  uploadProgress,
}: Attachment) =>
  !isUploading &&
  type === AttachmentTypes.VIDEO &&
  Number(uploadProgress) < 100;
